import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from '@core/auth/auth.service';
import { SessionUnavailableComponent } from '@core/auth/session-unavailable.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, SessionUnavailableComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (auth.sessionUnavailable()) {
      <app-session-unavailable />
    } @else {
      <router-outlet />
    }
  `,
})
export class AppComponent {
  protected readonly auth = inject(AuthService);
}
